import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { functionpermission, ManageServiceBO, saveServiceGroup } from '../manage-service.modal';
import { ManageService } from '../manage-service.service';
import { ServiceGroupDataservice } from './service-groupdateservice';


@Component({
  selector: 'app-service-group',
  templateUrl: './service-group.component.html',
  styleUrls: ['./service-group.component.scss']
})
export class ServiceGroupComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridServiceGroup') public gridServiceGroup: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  isSaveorUpdateBoolean:boolean=false;
  saveServiceGroupInfo: saveServiceGroup = new saveServiceGroup();
  MSFilterBo: ManageServiceBO = new ManageServiceBO();
  constructor(public DateService: ServiceGroupDataservice,
    public Msservice: ManageService,
    public global: GlobalComponent, public toasterservice: ToastrService) {
    
    this.GridList=DateService;
  }
  fp:functionpermission=new functionpermission()
  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.MSFilterBo.field="serviceGroupName";
    this.MSFilterBo.orderColumn="serviceGroupName";
    this.getServiceGroupFilter();
    this.getpermission();
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "Manage Services");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.Msservice.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}
  // ................................................dataChangeTax..............................................
  public dataChangeServiceGroup(SG): void {
    let val = (SG.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((SG.sorted || []).length) {
        this.MSFilterBo.orderColumn = SG.sorted[0].name;
        this.MSFilterBo.orderType = SG.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && SG.action.action != "clearFilter") {
      this.MSFilterBo.value = SG.action.currentFilterObject.value;
      this.MSFilterBo.field = SG.action.currentFilterObject.field;
      this.MSFilterBo.matchCase = SG.action.currentFilterObject.matchCase;
      this.MSFilterBo.operator = SG.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && SG.action.action == "clearFilter") {
        this.MSFilterBo.field = "serviceGroupName";
        this.MSFilterBo.matchCase = false;
        this.MSFilterBo.operator = "contains";
        this.MSFilterBo.value = "";
        this.MSFilterBo.type = "string";
      }
    }
    this.getServiceGroupFilter();
    if (val == "paging" && SG.action.name == "actionBegin") {
      // if (this.arraycol.length != 0) {
      //   if (this.arraycol[0].Question.Pagesize != Q.take) {
      //     this.arraycol[0].Question.Pagesize = Q.take
      //     // this.SaveColumnwidth();
      //   }
      // }
    }
  }
    //.........................................onActionTAx.....................................................
    public onActionServiceGroup(SG) {
      this.MSFilterBo.currentpageno = this.gridServiceGroup.pagerModule.pagerObj.currentPage;
      this.MSFilterBo.pageitem = this.gridServiceGroup.pagerModule.pagerObj.pageSize;
      if (SG.name == "actionBegin" && SG.requestType == "filterbeforeopen") {
        this.MSFilterBo.type = SG.columnType
      }
    }
  //...........................................getDetails..........................................
  getDetails(saveBos: saveServiceGroup) {
    this.saveServiceGroupInfo = JSON.parse(JSON.stringify(saveBos));

  }
  //............................................Refresh...................................................
  Refresh() {
    this.saveServiceGroupInfo = new saveServiceGroup();
    this.getServiceGroupFilter();

  }

  //.........................................getServiceGroupFilter.............................................
  getServiceGroupFilter() {
    this.DateService.execute(this.MSFilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridServiceGroup.height = '500';
      }
      else {
        this.gridServiceGroup.height = 'auto';
      }
    })
  }
  //.........................................SaveOrUpdateServiceGroup.............................................
  SaveOrUpdateServiceGroup() {
    this.isSaveorUpdateBoolean=true;
    let savepayload: saveServiceGroup = JSON.parse(JSON.stringify(this.saveServiceGroupInfo));
    savepayload.id = this.saveServiceGroupInfo.id;
    this.Msservice.saveServiceGroup(savepayload).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
        if (this.saveServiceGroupInfo.id == '00000000-0000-0000-0000-000000000000') {
          this.toasterservice.success('Service Group saved successfully!');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);

        }
        else if (this.saveServiceGroupInfo.id != '00000000-0000-0000-0000-000000000000') {
          this.toasterservice.success('Service Group updated successfully!');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
        }
        document.getElementById('openServiceGroupModal').click();
        this.saveServiceGroupInfo = new saveServiceGroup();
        this.getServiceGroupFilter();
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }

  showServiceGroupColumns() {
    this.gridServiceGroup.columnChooserModule.openColumnChooser(200, 50);
  }
  //..........................................DeleteServiceGroup...........................................................
  DeleteServiceGroup() {
    let params = new URLSearchParams();
    params.append("Id", this.deleteServiceGroupId);
    this.Msservice.DeleteServiceGroup(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toasterservice.success('Service Group deleted successfully!');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      document.getElementById('closeSGModal').click();
      this.getServiceGroupFilter();
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    });
  }
  clearServiceGroup() {
    this.saveServiceGroupInfo = new saveServiceGroup();
    
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  deleteServiceGroupId:string
  getDeleteId(data) 
  {
    this.deleteServiceGroupId=data
       
     }



}


